// Flow types automatically removed

import { Component, Fragment } from 'react';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import getter from 'dibs-object-getter';
import { Spinner } from 'dibs-elements/exports/Spinner';
import { InteriorsLandingRoomsHeader } from './components/InteriorsLandingRoomsHeader';
import { InteriorsLandingRooms } from './components/InteriorsLandingRooms';
import { InteriorsLandingMatchmakerBanner } from './components/InteriorsLandingMatchmakerBanner';
import { InteriorsLandingProjects } from './components/InteriorsLandingProjects';
import { InteriorsLandingDesigners } from './components/InteriorsLandingDesigners';
import { trackPageView } from '../shared/helpers/tracking';
import styles from './InteriorsLandingWrapper.scss';

const renderModule = (moduleOrder, index, cmsConfig) => {
    if (moduleOrder[index] === 'rooms') {
        return <InteriorsLandingRooms roomsModule={cmsConfig} />;
    } else if (moduleOrder[index] === 'projects') {
        return <InteriorsLandingProjects projectsModule={cmsConfig} />;
    } else if (moduleOrder[index] === 'designers') {
        return <InteriorsLandingDesigners designersModule={cmsConfig} />;
    }

    return null;
};

export class InteriorsLandingWrapperComponent extends Component {
    componentDidMount() {
        trackPageView();
    }

    render() {
        const { viewer } = this.props;

        if (!viewer) {
            return <Spinner containerClass={styles.spinner} dark />;
        }

        const interiorsLandingPage = getter(viewer).value('interiorsLandingPage');
        const roomsHeadModule = getter(viewer).at('interiorsLandingPage').value('roomsHeadModule');
        const moduleOrder = (
            getter(viewer).at('interiorsLandingPage').value('moduleOrder') || []
        ).filter(Boolean);
        return (
            <Fragment>
                <div className={`${styles.wrapper} primary-viewport-width`}>
                    <div className={`${styles.innerWrapper} primary-page-width`}>
                        <div className={styles.headerWrapper}>
                            <InteriorsLandingRoomsHeader roomsHeadModule={roomsHeadModule || {}} />
                        </div>
                        <div
                            className={styles.headerContentWrapper}
                            data-tn="interiors-landing-top-section-content"
                        >
                            {renderModule(moduleOrder, 0, interiorsLandingPage || {})}
                        </div>
                    </div>
                </div>
                <InteriorsLandingMatchmakerBanner />
                <div className={styles.landingSection}>
                    <div
                        className="primary-page-width"
                        data-tn="interiors-landing-bottom-section-content"
                    >
                        {renderModule(moduleOrder, 1, interiorsLandingPage || {})}
                        {renderModule(moduleOrder, 2, interiorsLandingPage || {})}
                    </div>
                </div>
            </Fragment>
        );
    }
}
export const InteriorsLandingWrapper = createFragmentContainer(InteriorsLandingWrapperComponent, {
    viewer: graphql`
        fragment InteriorsLandingWrapper_viewer on Viewer {
            interiorsLandingPage(id: $id, getLive: $getLive) {
                moduleOrder
                roomsHeadModule {
                    ...InteriorsLandingRoomsHeader_roomsHeadModule
                }
                ...InteriorsLandingRooms_roomsModule
                ...InteriorsLandingDesigners_designersModule
                ...InteriorsLandingProjects_projectsModule
            }
        }
    `,
});
